export const getCollisionElementOriginalLocationY = (state, ownProps) =>
    state.getIn(['app', 'collision', 'originalLocation', ownProps.elementId, 'position', 'y']);
